import { jsx as _jsx } from "react/jsx-runtime";
import { useIsMaxScreenSize } from 'ecosystem-marketplace-core/hooks/useScreenSize';
import * as ScreenSizes from 'ecosystem-marketplace-core/constants/layout/ScreenSizes';
import DesktopBrowseBar from './DesktopBrowseBar';
import MobileBrowseBar from './MobileBrowseBar';
export default function BrowseBar({
  hasActiveOfferingType = true,
  previewCollectionId
}) {
  const isMobile = useIsMaxScreenSize(ScreenSizes.SM);
  return isMobile ? /*#__PURE__*/_jsx(MobileBrowseBar, {}) : /*#__PURE__*/_jsx(DesktopBrowseBar, {
    hasActiveOfferingType: hasActiveOfferingType,
    previewCollectionId: previewCollectionId
  });
}